<template>
  <div class="mt-1">
    <v-chip-group>
      <v-chip
        v-if="!isSingleQuestion"
        v-motion
        :initial="{ opacity: 0, x: 10 }"
        :enter="{ opacity: 1, x: 0, scale: 1 }"
        :delay="100"
        class="bg-error"
        @click="toggleflag"
        label
        :prepend-icon="
          userQuestionStat?.flagged ? 'mdi-flag' : 'mdi-flag-outline'
        "
      >
        {{ userQuestionStat?.flagged ? "Unflag" : "Flag" }}
      </v-chip>
      <v-tooltip
        content-class="bg-primary"
        text="Number of times you have seen this question before."
        location="bottom"
      >
        <template v-slot:activator="{ props }">
          <v-chip
            v-motion
            :initial="{ opacity: 0, x: 10 }"
            :enter="{ opacity: 1, x: 0, scale: 1 }"
            :delay="200"
            :ripple="false"
            v-bind="props"
            label
            prepend-icon="mdi-eye-outline"
            variant="outlined"
          >
            {{ userQuestionStat ? userQuestionStat.attempted : 0 }}
          </v-chip>
        </template>
      </v-tooltip>

      <v-tooltip
        v-if="
          userQuestionStat &&
          userQuestionStat.attempted > 0 &&
          props.showStatChips
        "
        content-class="bg-primary"
        text="How often you got this question correct."
        location="bottom"
      >
        <template v-slot:activator="{ props }">
          <v-chip
            :ripple="false"
            v-bind="props"
            label
            prepend-icon="mdi-check"
            variant="outlined"
            v-motion
            :initial="{ opacity: 0, x: 10 }"
            :enter="{ opacity: 1, x: 0, scale: 1 }"
            :delay="300"
          >
            {{ userCorrectPerc }}%
          </v-chip>
        </template>
      </v-tooltip>

      <v-tooltip
        v-if="!isNaN(globalCorrectPerc) && props.showStatChips"
        content-class="bg-primary"
        text="How often others got this question correct."
        location="bottom"
      >
        <template v-slot:activator="{ props }">
          <v-chip
            :ripple="false"
            v-bind="props"
            label
            prepend-icon="mdi-check-all"
            variant="outlined"
            v-motion
            :initial="{ opacity: 0, x: 10 }"
            :enter="{ opacity: 1, x: 0, scale: 1 }"
            :delay="400"
          >
            {{ globalCorrectPerc }}%
          </v-chip>
        </template>
      </v-tooltip>
    </v-chip-group>
  </div>
</template>

<script setup>
  import { ref, computed } from "vue";

  const props = defineProps([
    "qId",
    "currentQuestionData",
    "userQuestions",
    "showStatChips",
    "isSingleQuestion",
    "collectionPath",
  ]);
  // currentQuestionData contains the question data which contains the global stats for the question that we will use.
  // userQuestions contains all of the questions the user has attempted and the associated stats.

  const globalCorrectPerc = computed(() => {
    return (
      (props.currentQuestionData.stats.correct /
        props.currentQuestionData.stats.attempted) *
      100
    ).toFixed(0);
  });

  const userQuestionStat = computed(() => {
    if (!props.userQuestions) return null;
    return props.userQuestions.find((question) => question.qId === props.qId);
  });

  const userCorrectPerc = computed(() => {
    if (!userQuestionStat.value) return null;
    return (
      (userQuestionStat.value.correct / userQuestionStat.value.attempted) *
      100
    ).toFixed(0);
  });

  import { useAlertStore } from "@/store/alert";
  import { useStatsStore } from "@/store/stats";
  const alertStore = useAlertStore();
  const statsStore = useStatsStore();
  import { useFirestore, useCurrentUser } from "vuefire";
  const currentUser = useCurrentUser();
  const db = useFirestore();

  import { collection, doc, setDoc, getDoc } from "firebase/firestore";
  const toggleflag = async () => {
    let dataToUpdate;
    if (!userQuestionStat.value) {
      // The question does not exist for the user yet, so we need to create it.
      dataToUpdate = {
        flagged: true,
        attempted: 0,
        correct: 0,
        lastReviewDate: new Date(),
        boxNumber: 0,
        answerSelections: {},
      };
    } else {
      dataToUpdate = {
        flagged: !userQuestionStat.value.flagged,
      };
    }

    let statsName;
    if (props.collectionPath.includes("part-1-question-bank")) {
      statsName = "part1Stats";
    } else if (props.collectionPath === "") {
      // part-2-question-bank has empty path
      statsName = "stats";
    } else if (props.collectionPath.includes("duke-elder-question-bank")) {
      statsName = "dukeElderStats";
    } else {
      statsName = "stats";
    }

    try {
      await setDoc(
        doc(collection(db, "users"), currentUser.value.uid),
        {
          [statsName]: {
            questions: {
              [props.qId]: dataToUpdate,
            },
          },
        },
        { merge: true }
      );
    } catch (error) {
      alertStore.showAlert(
        "An error occurred, could not flag question. Please check your internet connection and try again.",
        "error"
      );
    }
  };
</script>
